import React from 'react';

const PaperCard = ({ hit, onPlay, onDownload }) => (
  <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
    <div className="mb-4">
      <div className="flex items-center justify-between mb-3">
        <span className="inline-block px-3 py-1 text-sm font-medium text-indigo-600 bg-indigo-50 rounded-full">
          {hit.category}
        </span>
        {hit.isFree ? (
          <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded-full">Free</span>
        ) : (
          <span className="text-xs font-semibold text-purple-600 bg-purple-50 px-2 py-1 rounded-full">Premium</span>
        )}
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2 leading-snug">{hit.title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed">{hit.description}</p>
    </div>

    <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
      <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.369 4.369 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
      </svg>
      {hit.duration}
    </div>

    <div className="flex gap-2">
      <button
        onClick={() => onPlay(hit)}
        className="flex-1 stripe-gradient text-white py-2 px-4 rounded-lg text-sm font-medium hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
        </svg>
        Play
      </button>
      <button
        onClick={() => onDownload(hit)}
        className="border border-gray-300 text-gray-700 py-2 px-4 rounded-lg text-sm font-medium hover:border-gray-400 transition-colors flex items-center justify-center gap-2"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        PDF
      </button>
    </div>
  </div>
);

export default PaperCard;
